import effectManager from '../../module/effect';

let effect = new effectManager();

export default class fixedButton {
    constructor($target) {
        this.$target = $target;
        this.$btnText = $("#l-fixed-btn-text")
        this.$btnCircle = $("#l-fixed-btn-circle")
        this.$text = $target.find(".js__rewrite");

        this.status = {
            show : false,
            showTimer:"",
            sizeFlg : false,
            fit : false,
            fitPosiFlg : false,
            size :{
                fullW : this.$target.innerWidth(),
                fullH : this.$target.innerHeight(),
                w : this.$target.innerWidth()/2,
                h : this.$target.innerHeight()/2
            },
            position:{
                x : 0,
                y : 0,
                prevX : 0,
                prevY : 0,
            }
        }

        effect.scale(this.$target,"set");

    }
    update(mode){

        let _this = this;

        setTimeout(()=>{
            TweenMax.to(_this.$text,0.3,{opacity:0,onComplete:()=>{
                    _this.$text.text(mode==="open"? "CLOSE" : "MORE")
                    TweenMax.to(_this.$text,0.3,{opacity:1})
            }})
        },7e2)
    }
    show(){ /* 表示動作 */
        this.$target.removeClass("is-out")
        if(!Useragnt.tablet) this.status.showTimer = setTimeout(()=>effect.scale(this.$target,"show"),2e3) /* タブレットでは詳細画面以外では表示させない */
    }
    out(){ /* 消す動作 */
        this.$target.addClass("is-out")
        if(!Useragnt.tablet){
            TweenMax.killTweensOf(this.$target);
            clearTimeout(this.status.showTimer)
            effect.scale(this.$target,"out");
        }
    }
    fit(){ /* 位置固定 */
        this.$target.addClass("is-fit")
        if(Useragnt.tablet) effect.scale(this.$target,"show")
    }
    free(){ /* 位置固定を解除 */
        this.$target.removeClass("is-fit")
        if(Useragnt.tablet) effect.scale(this.$target,"out")
    }
    sizeDefault(){
        if(this.status.sizeFlg||Useragnt.tablet) return;
        this.status.sizeFlg = true;
        TweenMax.to(this.$btnText,0.4,{
            opacity:1,
            ease: "Power2.easeIn",
        })
        TweenMax.to(this.$target.children(),0.4,{
            width :  100+"%",
            height:  100+"%",
            // scale : 1,
            ease: "Power2.easeIn",
        })
    }
    sizeScaleDown(){
        if(!this.status.sizeFlg||Useragnt.tablet) return;
        this.status.sizeFlg = false;

        TweenMax.to(this.$btnText,0.3,{
            opacity:1,
            ease: "Power2.easeOut",
        })
        TweenMax.to(this.$btnCircle,0.8,{
            scale :1,
            ease: "Expo.easeOut",
        })
    }
    sizeScaleUp(){
        if(!this.status.sizeFlg||Useragnt.tablet) return;
        this.status.sizeFlg = false;

        TweenMax.to(this.$btnText,0.3,{
            opacity:0.2,
            ease: "Power2.easeOut",
        })
        TweenMax.to(this.$btnCircle,0.8,{
            scale :1.2,
            ease: "Expo.easeOut",
        })
    }
    sizeSmall(){
        if(!this.status.sizeFlg) return;
        this.status.sizeFlg = false;

        TweenMax.to(this.$btnText,0.3,{
            opacity:0,
            ease: "Power2.easeOut",
        })
        TweenMax.to(this.$target.children(),0.8,{
            width :  50+"%",
            height:  50+"%",
            ease: "Expo.easeOut",
        })
    }
    render(mouse){


        if(this.status.fitPosiFlg) return;
        
        this.status.position.x = mouse.x-this.status.size.w;
        this.status.position.y = mouse.y-this.status.size.h

        if(
            Math.abs(this.status.position.prevX-this.status.position.x)>0.1&&
            Math.abs(this.status.position.prevY-this.status.position.y)>0.1
        ){
            TweenMax.set(this.$target,{
                x:this.status.position.x,
                y:this.status.position.y
            });
        }else{
            if(this.status.fit) this.status.fitPosiFlg = true;
        }


        this.status.position.prevX = this.status.position.x;
        this.status.position.prevY = this.status.position.y;

    }
    resize(){

    }
}